/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * Buyer phone number API call flow extracted from `useForm/index.tsx`.
 *
 * `applyApiCallFlow` runs the "API call" field flow that resolves a
 * buyer phone number for redirect-style category pages.
 */

import { delay } from "@lib/shared/helpers";
import {
    BuyerPhoneNumberService,
    BuyerZipcodePhoneNumberOptions,
} from "@services/buyerPhoneNumberService";
import { Category } from "@lib/shared/types";
import {
    ActionTypes,
    FieldsData,
    FormReducerAction,
    FormSubmitOptions,
} from "../types";
interface UseApiCallParams {
    fieldsState: FieldsData;
    dispatch: (action: FormReducerAction) => void;
    setApiCallLoading: (v: boolean) => void;
    setBuyerPhoneNumber: (v: string) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    category: Category | null | undefined;
}

export const useApiCall = ({
    fieldsState,
    dispatch,
    setApiCallLoading,
    setBuyerPhoneNumber,
    category,
}: UseApiCallParams) => {
    const applyApiCallFlow = async (
        options?: Pick<FormSubmitOptions, "apiCallField">,
    ) => {
        // Show loading state
        setApiCallLoading(true);

        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: true,
        });

        let result = "";
        const data: BuyerZipcodePhoneNumberOptions = {
            zipCode: fieldsState["zipCode"].value,
            categoryId: category?.id,
            onSuccess: (phoneNumber: string) => {
                result = phoneNumber;
            },
            onError: () => {
                result = "";
            },
        };

        await BuyerPhoneNumberService.handleApiCall(
            options?.apiCallField,
            data,
        );
        // Stop loading after API call
        await delay(category?.config?.loadingThreshold || 5000);
        setBuyerPhoneNumber(result);
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: false,
        });

        return result;
    };

    return {
        applyApiCallFlow,
    };
};
